module.exports = __webpack_public_path__ + "static/media/DWK_04.a63bd752.jpg";